import type { ReactElement } from 'react';
import { EntityFilterChip } from 'components/filters/EntityFilterChip';
import { companyFieldProps } from './CompanyFields';

export function CompanyFilterChip({
  name,
  label,
  isMulti,
}: {
  name: string;
  label?: string;
  isMulti?: boolean;
}): ReactElement {
  return (
    <EntityFilterChip
      name={name}
      label={label}
      url="core/companies/"
      getOptionLabel={(a) => a.internal_name}
      getOptionValue={companyFieldProps.getOptionValue}
      formatOptionLabel={companyFieldProps.formatOptionLabel}
      filter={{ include_branches: true }}
      isMulti={isMulti}
    />
  );
}
